import React from 'react'
import { CurrencyLabel } from "../Labels";
import { ItemCell } from "..";

function SomatoriasConciliacao({ somatoriasConciliacao }) {
  return (
    <tr>
    <ItemCell
      valueCol={''} 
    />
    <ItemCell
      valueCol={''} 
    />
    <ItemCell
      valueCol={'Totais'} 
    />
    <ItemCell
      valueCol={somatoriasConciliacao.qtdPO} 
    />
    <ItemCell
      valueCol={''} 
    />
    <ItemCell
      valueCol={''} 
    />
    <ItemCell
      valueCol={{text:
        <CurrencyLabel 
          amount={parseFloat(somatoriasConciliacao.totalItemPO)} 
          locale="br" />
      }} 
    />
    <ItemCell
      valueCol={somatoriasConciliacao.qtdNF} 
    />
    <ItemCell
      valueCol={''} 
    />
    <ItemCell
      valueCol={''} 
    />
    <ItemCell
      valueCol={{text:
        <CurrencyLabel 
          amount={parseFloat(somatoriasConciliacao.totalItemNF)} 
          locale="br" />
      }}
    />
  </tr>
)}

export default SomatoriasConciliacao;